import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:       '/importfile/dashboard',
	title:      'menu.importfile-model',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/importfile/dashboard';
	},
});
